module.exports = __webpack_public_path__ + "img/11_sustainable_cities_and_communities.d800e5e1.svg";